<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

@if (workflow) {
  <form
    class="modal-content"
    #f="ngForm"
    (ngSubmit)="f.valid && next(f)"
    (dragover)="fileDragDropBody($event)"
    (drop)="fileDragDropBody($event)"
    (keydown.enter)="handleEnterKeyPress($event)">
    <div class="modal-header">
      <div class="workflow-title">
        @if (workflow.icon.image) {
          <img
            class="workflow-image"
            [src]="workflow.icon.image"
            [alt]="'SDE_WORKFLOW_ICON' | xdaTranslate" />
        } @else {
          <div
            class="workflow-image {{
              workflow.icon.color
            }} text-center align-middle d-flex align-items-center justify-content-center">
            <div class="{{ workflow.icon.glyph }} xglsize-32"></div>
          </div>
        }
        <h5 class="modal-title" [xdaTranslate]="workflow.name"></h5>
      </div>
    </div>
    <div class="modal-body" tabindex="-1">
      @switch (step.name) {
        <!-- input settings -->
        @case ('input') {
          <section>
            @if (onFirstService) {
              <div class="form-group input">
                <div class="form-group">
                  <h5
                    class="section-label"
                    [xdaTranslate]="'SDE_INPUT_SETTINGS'"></h5>
                </div>
                <!-- Best results achieved with... -->
                <div class="best-results info">
                  <span [xdaTranslate]="workflow.input.description"></span>
                  <span>&nbsp;</span>
                  <span
                    [xdaTranslate]="workflow.input.maxPageMessage"
                    [formatValues]="
                      workflow.input.maxPageLimit.toString() || '200'
                    "></span>
                  @if (workflow.input.maxSizeMessage !== '') {
                    <span>&nbsp;</span>
                  }
                  <span
                    [xdaTranslate]="workflow.input.maxSizeMessage"
                    [formatValues]="
                      workflow.input.maxSizeLimit.toString() || '30'
                    "></span>
                  <span>. </span>
                  @if (containsTranslate()) {
                    <span xdaTranslate>SDE_ALL_IMAGE_FILES1</span>
                  }
                  @if (isGoogleTranslation()) {
                    <div
                      class="mt-1"
                      [xdaTranslate]="workflow.input.detail"></div>
                  }
                </div>
                <!-- Non merge workflow input -->
                @if (!docMergeOptions) {
                  <div>
                    @if (isAdvancedPlan && cloudRepos.length) {
                      <div>
                        <xrx-select
                          inlineLabel="SDE_SELECT_REPOSITORY"
                          type="group"
                          [list]="inputSources"
                          localize="key"
                          property="key"
                          [(selectedItem)]="selectedInputSource"
                          (change)="selectInputSource($event)"></xrx-select>
                      </div>
                    }
                    <!-- Local Drive Input -->
                    @if (inputSource.value === 'SDE_LOCAL_FILE') {
                      <div class="local-drive">
                        <xrx-multi-file-select
                          [(ngModel)]="input.uploadFiles"
                          maxFiles="{{ input.maxSelection }}"
                          minFiles="{{ input.minSelection }}"
                          fileTypes="{{ input.fileTypes.asString }}"
                          mode="batch"
                          name="inputMultiSelect"
                          id="inputMultiSelect"
                          [sortable]="false"
                          [fileTypesAccepted]="input.fileTypes.asAccept"
                          (fileDropped)="handleUploadFileInputs($event)">
                        </xrx-multi-file-select>
                      </div>
                    }
                    @if (inputSource.value !== 'SDE_LOCAL_FILE') {
                      <div class="input-cloud-choice">
                        <div>
                          @for (
                            cdoc of input.cloudRepoInputs;
                            track cdoc;
                            let i = $index
                          ) {
                            <div class="selected-cloud-folder form-inline">
                              <div
                                class="form-control d-flex align-items-center"
                                [ngClass]="{
                                  'is-invalid':
                                    input.cloudRepoInputs.length > 1 &&
                                    !validateSpecialCharacters(cdoc.file),
                                }">
                                <div class="text-truncate">
                                  {{ cdoc.file.name }}
                                </div>
                              </div>
                              <button
                                type="button"
                                class="xrx-btn btn-secondary ml-2"
                                (click)="changeCloudInput(cdoc)"
                                xdaTranslate>
                                SDE_CHANGE
                              </button>
                              <button
                                type="button"
                                class="xrx-btn btn-secondary btn-short xgl-change"
                                [attr.aria-label]="'SDE_CHANGE' | xdaTranslate"
                                (click)="changeCloudInput(cdoc)"></button>
                            </div>
                          }
                          <!-- blank row -- Add -->
                          @if (
                            !input.cloudRepoInputs ||
                            input.cloudRepoInputs.length < input.maxSelection
                          ) {
                            <div class="selected-cloud-folder form-inline">
                              <div
                                class="form-control d-flex align-items-center">
                                <div class="text-truncate"></div>
                              </div>
                              <button
                                type="button"
                                class="xrx-btn btn-secondary ml-2"
                                (click)="changeCloudInput(null)"
                                xdaTranslate>
                                SDE_ADD
                              </button>
                              <button
                                type="button"
                                class="xrx-btn btn-secondary btn-short xgl-file_add"
                                [attr.aria-label]="'SDE_ADD' | xdaTranslate"
                                (click)="changeCloudInput(null)"></button>
                            </div>
                          }
                          @if (
                            !isGoodToGo &&
                            (!input.cloudRepoInputs ||
                              input.cloudRepoInputs.length < 1)
                          ) {
                            <div class="fileinput-error">
                              <span
                                class="text-danger"
                                [xdaTranslate]="'SDE_REQUIRED_FIELD1'"></span>
                            </div>
                          }
                          @if (specialCharactersInCloudFileName) {
                            <div class="fileinput-error">
                              <span
                                class="text-danger"
                                [xdaTranslate]="'SDE_CHARACTERS_CANNOT_BE'"
                                [formatValues]="'\&quot;?;&lt;&gt;|:\'*%^&amp;#+`\\\/'"></span>
                            </div>
                          }
                          <div class="supported-formats">
                            <span
                              class="info"
                              [xdaTranslate]="'SDE_SUPPORTED_FILE_FORMATS1'"
                              [formatValues]="input.fileTypes.asString"></span>
                          </div>
                          <div class="info-wrapper">
                            @if (input.maxSelection !== input.minSelection) {
                              <span
                                class="info"
                                [xdaTranslate]="'SDE_SELECT_UP_FMTSTR1'"
                                [formatValues]="input.maxSelection"></span>
                            }
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                }
                <!-- Document merge -->
                @if (isMergeWorkflow) {
                  <div>
                    <div class="cb">
                      <xrx-radio
                        id="radio"
                        [list]="docMergeOptions"
                        property="value"
                        localize="value"
                        desc="desc"
                        [(checkedItem)]="mergeMode"
                        (checkedItemChange)="toggleMergeMode()"></xrx-radio>
                    </div>
                    @if (isAdvancedPlan && cloudRepos.length) {
                      <div>
                        <xrx-select
                          inlineLabel="SDE_SELECT_REPOSITORY"
                          type="group"
                          [list]="inputSources"
                          localize="key"
                          property="key"
                          [(selectedItem)]="selectedInputSource"
                          (change)="selectInputSource($event)"></xrx-select>
                      </div>
                    }
                    <!-- Local Drive Input for Merge-->
                    @if (inputSource.value === 'SDE_LOCAL_FILE') {
                      <div class="form-group local-file-wrapper">
                        <xrx-multi-file-select
                          [(ngModel)]="input.uploadFiles"
                          maxFiles="{{ input.maxSelection }}"
                          minFiles="{{ input.minSelection }}"
                          fileTypes="{{ input.fileTypes.asString }}"
                          mode="merge"
                          name="inputMultiSelect"
                          id="inputMultiSelect"
                          [sortable]="false"
                          [fileTypesAccepted]="input.fileTypes.asAccept"
                          (fileDropped)="handleUploadFileInputs($event)">
                        </xrx-multi-file-select>
                        @if (mergeMode.value === 'SDE_INSERT') {
                          <div class="insertInto">
                            <xrx-input
                              type="number"
                              id="insertAfter"
                              name="insertAfter"
                              [(ngModel)]="input.insertPageNumber"
                              [required]="true"
                              [maxValue]="input.maxInsertPageNumber"
                              [error]="input.insertPageNumberError"
                              [minValue]="1"
                              (change)="onPageNumberChange()"
                              label="SDE_INSERT_DOCUMENT_1">
                            </xrx-input>
                          </div>
                        }
                      </div>
                    }
                    <!-- Cloud Repo Input for Merge-->
                    @if (inputSource.value === 'SDE_CLOUD_REPO') {
                      <div>
                        <div>
                          @switch (mergeMode.value) {
                            <!-- Cloud Repo Document Insert -->
                            @case ('SDE_INSERT') {
                              <div>
                                <div class="input-cloud-choice">
                                  @for (
                                    cdoc of input.cloudRepoInputs;
                                    track cdoc;
                                    let i = $index
                                  ) {
                                    <div
                                      class="selected-cloud-folder form-inline">
                                      <div
                                        class="form-control d-flex align-items-center"
                                        [ngClass]="{
                                          'is-invalid':
                                            !validateSpecialCharacters(
                                              cdoc.file
                                            ),
                                        }">
                                        <div class="text-truncate">
                                          {{ cdoc.file.name }}
                                        </div>
                                      </div>
                                      <button
                                        type="button"
                                        class="xrx-btn btn-secondary ml-2"
                                        (click)="changeCloudInput(cdoc)"
                                        xdaTranslate>
                                        SDE_CHANGE
                                      </button>
                                      <button
                                        type="button"
                                        class="xrx-btn btn-secondary btn-short xgl-change"
                                        [attr.aria-label]="
                                          'SDE_CHANGE' | xdaTranslate
                                        "
                                        (click)="
                                          changeCloudInput(cdoc)
                                        "></button>
                                    </div>
                                  }
                                  <!--blank row -- Add -->
                                  @if (
                                    !input.cloudRepoInputs ||
                                    input.cloudRepoInputs.length < 2
                                  ) {
                                    <div
                                      class="selected-cloud-folder form-inline">
                                      <div
                                        class="form-control d-flex align-items-center">
                                        <div class="text-truncate"></div>
                                      </div>
                                      <button
                                        type="button"
                                        class="xrx-btn btn-secondary ml-2"
                                        (click)="changeCloudInput(null)"
                                        xdaTranslate>
                                        SDE_ADD
                                      </button>
                                      <button
                                        type="button"
                                        class="xrx-btn btn-secondary btn-short xgl-file_add"
                                        [attr.aria-label]="
                                          'SDE_ADD' | xdaTranslate
                                        "
                                        (click)="
                                          changeCloudInput(null)
                                        "></button>
                                    </div>
                                  }
                                  @if (
                                    !isGoodToGo &&
                                    (!input.cloudRepoInputs ||
                                      input.cloudRepoInputs.length < 2)
                                  ) {
                                    <div class="fileinput-error">
                                      <span
                                        class="text-danger"
                                        [xdaTranslate]="'SDE_REQUIRED_FIELD1'"></span>
                                    </div>
                                  }
                                  @if (specialCharactersInCloudFileName) {
                                    <div class="fileinput-error">
                                      <span
                                        class="text-danger"
                                        [xdaTranslate]="'SDE_CHARACTERS_CANNOT_BE'"
                                        [formatValues]="'\&quot;?;&lt;&gt;|:\'*%^&amp;#+`\\\/'"></span>
                                    </div>
                                  }
                                  <div class="supported-formats">
                                    <span
                                      class="info"
                                      [xdaTranslate]="'SDE_SUPPORTED_FILE_FORMATS1'"
                                      [formatValues]="
                                        input.fileTypes.asString
                                      "></span>
                                  </div>
                                  @if (
                                    input.maxSelection === input.minSelection
                                  ) {
                                    <span
                                      class="info"
                                      [xdaTranslate]="'SDE_SELECT_FMTSTR_FILES'"
                                      [formatValues]="
                                        input.maxSelection
                                      "></span>
                                  }
                                  @if (
                                    input.cloudRepoInputs &&
                                    input.cloudRepoInputs.length === 2
                                  ) {
                                    <div class="insertInto">
                                      <xrx-input
                                        type="number"
                                        id="insertAfter"
                                        name="insertAfter"
                                        [(ngModel)]="input.insertPageNumber"
                                        [required]="true"
                                        [maxValue]="input.maxInsertPageNumber"
                                        [error]="input.insertPageNumberError"
                                        [minValue]="1"
                                        (change)="onPageNumberChange()"
                                        label="SDE_INSERT_DOCUMENT_1">
                                      </xrx-input>
                                    </div>
                                  }
                                </div>
                              </div>
                            }
                            <!--  Cloud Repo Document concatenate -->
                            @case ('SDE_CONCATENATE') {
                              <div>
                                <div class="input-cloud-choice">
                                  @for (
                                    cdoc of input.cloudRepoInputs;
                                    track cdoc;
                                    let i = $index
                                  ) {
                                    <div
                                      class="selected-cloud-folder form-inline">
                                      <div
                                        class="form-control d-flex align-items-center"
                                        [ngClass]="{
                                          'is-invalid':
                                            !validateSpecialCharacters(
                                              cdoc.file
                                            ),
                                        }">
                                        <div class="text-truncate">
                                          {{ cdoc.file.name }}
                                        </div>
                                      </div>
                                      <button
                                        type="button"
                                        class="xrx-btn btn-secondary ml-2"
                                        (click)="changeCloudInput(cdoc)"
                                        xdaTranslate>
                                        SDE_CHANGE
                                      </button>
                                      <button
                                        type="button"
                                        class="xrx-btn btn-secondary btn-short xgl-change"
                                        [attr.aria-label]="
                                          'SDE_CHANGE' | xdaTranslate
                                        "
                                        (click)="
                                          changeCloudInput(cdoc)
                                        "></button>
                                      <div
                                        class="reorder-cloud up"
                                        [class.is-hidden]="i === 0"
                                        (click)="
                                          moveInputFileUp(
                                            input.cloudRepoInputs,
                                            i
                                          )
                                        ">
                                        <i class="xgl-arrow_up_square"></i>
                                      </div>
                                      <div
                                        class="reorder-cloud down"
                                        [class.is-hidden]="
                                          i === 0 ||
                                          i === input.cloudRepoInputs.length - 1
                                        "
                                        (click)="
                                          moveInputFileDown(
                                            input.cloudRepoInputs,
                                            i
                                          )
                                        ">
                                        <i class="xgl-arrow_down_square"></i>
                                      </div>
                                    </div>
                                  }
                                  <!-- blank row -- Add -->
                                  @if (
                                    input.cloudRepoInputs &&
                                    input.cloudRepoInputs.length <
                                      input.maxSelection
                                  ) {
                                    <div
                                      class="selected-cloud-folder form-inline">
                                      <div
                                        class="form-control d-flex align-items-center">
                                        <div class="text-truncate"></div>
                                      </div>
                                      <button
                                        type="button"
                                        class="xrx-btn btn-secondary ml-2"
                                        (click)="changeCloudInput(null)"
                                        xdaTranslate>
                                        SDE_ADD
                                      </button>
                                      <button
                                        type="button"
                                        class="xrx-btn btn-secondary btn-short xgl-file_add"
                                        [attr.aria-label]="
                                          'SDE_ADD' | xdaTranslate
                                        "
                                        (click)="
                                          changeCloudInput(null)
                                        "></button>
                                      <!-- use [class.is-hidden]="true" to hold place for correct layout -->
                                      <div>
                                        <i
                                          [class.is-hidden]="true"
                                          class="xgl-arrow_up_square"></i>
                                      </div>
                                      <div>
                                        <i
                                          [class.is-hidden]="true"
                                          class="xgl-arrow_down_square"></i>
                                      </div>
                                    </div>
                                  }
                                  @if (
                                    !isGoodToGo &&
                                    (!input.cloudRepoInputs ||
                                      input.cloudRepoInputs.length < 2)
                                  ) {
                                    <div class="fileinput-error">
                                      <span
                                        class="text-danger"
                                        [xdaTranslate]="'SDE_REQUIRED_FIELD1'"></span>
                                    </div>
                                  }
                                  @if (specialCharactersInCloudFileName) {
                                    <div class="fileinput-error">
                                      <span
                                        class="text-danger"
                                        [xdaTranslate]="'SDE_CHARACTERS_CANNOT_BE'"
                                        [formatValues]="'\&quot;?;&lt;&gt;|:\'*%^&amp;#+`\\\/'"></span>
                                    </div>
                                  }
                                  <div class="supported-formats">
                                    <span
                                      class="info"
                                      [xdaTranslate]="'SDE_SUPPORTED_FILE_FORMATS1'"
                                      [formatValues]="
                                        input.fileTypes.asString
                                      "></span>
                                  </div>
                                  <div class="info-wrapper">
                                    @if (
                                      input.maxSelection !== input.minSelection
                                    ) {
                                      <span
                                        class="info"
                                        [xdaTranslate]="'SDE_SELECT_UP_FMTSTR1'"
                                        [formatValues]="
                                          input.maxSelection
                                        "></span>
                                    }
                                  </div>
                                </div>
                              </div>
                            }
                          }
                        </div>
                      </div>
                    }
                  </div>
                }
                @if (
                  isAdvancedPlan &&
                  pageRangeSupported &&
                  !docMergeOptions &&
                  !input.isBatchInput
                ) {
                  <div class="page-selector">
                    <label [xdaTranslate]="'SDE_PAGE_RANGE'"></label>
                    <div>
                      <xrx-radio
                        display="inline"
                        [list]="pageRangeOptions"
                        property="value"
                        localize="label"
                        [(checkedItem)]="pageRangeOption">
                      </xrx-radio>
                    </div>
                    @if (pageRangeOption.value == 'SDE_SELECT_PAGES') {
                      <div class="input-selection">
                        <xrx-input
                          type="text"
                          (keyup)="rangeOnKeyUp($event)"
                          [(ngModel)]="input.selectedPages"
                          [autofocus]="false"
                          [required]="false"
                          [error]="input.selectedPagesError"
                          id="pageRange"
                          name="pageRange"
                          [pattern]="input.selectedPagesValidation"
                          [patternerror]="input.selectedPagesValidationError"
                          placeholder="SDE_ENTER_PAGE_RANGE1"></xrx-input>
                        <div class="page-select-help">
                          <span
                            class="info"
                            [xdaTranslate]="'SDE_ADD_COMMAS_DASHES'"></span>
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            }
            <div class="form-group mt-4 mb-0">
              <button
                type="button"
                class="xrx-btn btn-secondary w-100"
                (click)="resetInputSettings()">
                <span
                  class="btn-label"
                  [xdaTranslate]="'SDE_RESET_PAGE'"></span>
              </button>
            </div>
          </section>
        }
        <!-- service settings -->
        @case ('service') {
          <section>
            @for (
              servSetting of serviceSettings;
              track servSetting;
              let i = $index
            ) {
              <div>
                @if (i === servicePageIndex) {
                  <div>
                    <div class="form-group input">
                      <div class="form-group">
                        <h5
                          class="section-label"
                          [xdaTranslate]="'SDE_0_SETTINGS'"
                          [formatValues]="servSetting.name"></h5>
                      </div>
                    </div>
                    <div
                      class="form-group service-params service-{{
                        servSetting.name | lowercase | slice: 4
                      }}">
                      @for (
                        param of servSetting.settings;
                        track param;
                        let i = $index;
                        let last = $last
                      ) {
                        <div
                          class="service-param pram-{{ param.name }}"
                          [ngClass]="{
                            'service-param-flow':
                              param.type === 4 || param.type === 11,
                          }">
                          <xrx-setting
                            [(setting)]="servSetting.settings[i]"
                            (validation)="
                              validateServiceSettings($event, param)
                            "></xrx-setting>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            }
            @if (showResetServiceSettings) {
              <div class="form-group mt-4 mb-0">
                <button
                  type="button"
                  class="xrx-btn btn-secondary w-100"
                  (click)="resetServiceSettings()">
                  <span
                    class="btn-label"
                    [xdaTranslate]="'SDE_RESET_PAGE'"></span>
                </button>
              </div>
            }
          </section>
        }
        <!-- output settings -->
        @case ('output') {
          <section>
            <div class="form-group output">
              <div class="form-group">
                <h5
                  class="section-label"
                  [xdaTranslate]="workflow.output.settingTitle"></h5>
              </div>
              <!-- output file name for single input-->
              <section>
                @if (!isBatchInput() && workflow.output.ouputFileNameEditable) {
                  <div class="file-name d-flex">
                    <div class="w-100">
                      <xrx-output-file-input
                        type="text"
                        id="fileName"
                        name="fileName"
                        [(ngModel)]="output.fileName"
                        [isFileName]="true"
                        [fileExtension]="output.fileTypes.extension.value"
                        [addDateTime]="output.addDateTime"
                        [maxlength]="128"
                        placeholder="Enter a Filename"
                        [required]="true"
                        label="SDE_FILENAME"
                        [pattern]="output.fileNameValidation"
                        [patternerror]="output.fileNameError"
                        [helpBlock]="
                          workflow.output.file.description || ''
                        "></xrx-output-file-input>
                    </div>
                    @if (output.fileTypes.asArray.length > 1) {
                      <div class="output-file-ext">
                        <div>
                          <xrx-select
                            [list]="output.fileTypes.asArray"
                            property="value"
                            localize="key"
                            [(selectedItem)]="
                              output.fileTypes.extension
                            "></xrx-select>
                        </div>
                      </div>
                    }
                  </div>
                }
                @if (
                  !isBatchInput() && workflow.output.dateTimeSelectionEnabled
                ) {
                  <div class="append-date-time">
                    <xrx-checkbox
                      label="SDE_APPEND_DATE_TIME2"
                      [(checkBoxValue)]="output.addDateTime"
                      (checkBoxValueChange)="refreshOutputFilename()"
                      name="appendDateTime"></xrx-checkbox>
                  </div>
                }
                <!-- output file names for batch inputs-->
                @if (isBatchInput()) {
                  <div>
                    <div class="file-name d-flex">
                      @if (output.fileTypes.asArray.length > 1) {
                        <div [ngClass]="{ 'output-file-ext': !isBatchInput() }">
                          <label xdaTranslate>SDE_FILE_TYPE</label>
                          @if (!isTranslateWorkflow) {
                            <div>
                              <xrx-select
                                [list]="output.fileTypes.asArray"
                                property="value"
                                localize="key"
                                [(selectedItem)]="
                                  output.fileTypes.extension
                                "></xrx-select>
                            </div>
                          }
                          @if (isTranslateWorkflow) {
                            <div>
                              <xrx-radio
                                [list]="translateFileTypes"
                                property="value"
                                localize="display"
                                [(checkedItem)]="
                                  selectedTranslateFileType
                                "></xrx-radio>
                            </div>
                          }
                        </div>
                      }
                      <ng-template #retainInputTypeTooltip>
                        <div class="d-flex flex-column">
                          <span
                            [xdaTranslate]="'SDE_MICROSOFT_OFFICE_DOCUMENTS'"></span>
                          <span [xdaTranslate]="'SDE_IMAGE_RTF_FILES'"></span>
                        </div>
                      </ng-template>
                      @if (isTranslateWorkflow) {
                        <div class="auto-type-tooltip">
                          <i
                            class="glyph-style xgl-help"
                            [ngbTooltip]="retainInputTypeTooltip"></i>
                        </div>
                      }
                    </div>
                    <label
                      [ngClass]="{
                        'filename-label': output.fileTypes.asArray.length > 1,
                      }"
                      xdaTranslate
                      >SDE_FILENAME</label
                    >
                    <div>
                      @for (uploadFile of input.uploadFiles; track uploadFile) {
                        <div class="batch-file-name">
                          <div>
                            {{ uploadFile.outputFileName
                            }}<span xdaTranslate>SDE_DATE_TIME4</span
                            ><span>.</span
                            >{{ getOutputFormatForBatchInput(uploadFile.name) }}
                          </div>
                        </div>
                      }
                      @for (
                        cloudRepoFile of input.cloudRepoInputs;
                        track cloudRepoFile
                      ) {
                        <div class="batch-file-name">
                          <div>
                            {{ cloudRepoFile.outputFileName
                            }}<span xdaTranslate>SDE_DATE_TIME4</span
                            ><span>.</span
                            >{{
                              getOutputFormatForBatchInput(
                                cloudRepoFile.file.name
                              )
                            }}
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                }
              </section>
              <!-- password protection -->
              @if (
                canBePasswordProtected() &&
                workflow.output.passwordProtectionEnabled
              ) {
                <div class="output-selection">
                  <div
                    class="option-toggle"
                    [ngClass]="{ disabled: passwordProtectionDisabled }"
                    [ngbTooltip]="passwordProtectionToolTip"
                    [disableTooltip]="!passwordProtectionDisabled">
                    <xrx-toggle-switch
                      [label]="'SDE_PASSWORD_PROTECTION'"
                      [glyph]="'xgl-locked'"
                      [isMfd]="false"
                      [switchOn]="output.passwordProtection"
                      (toggle)="
                        output.passwordProtection = !output.passwordProtection
                      "
                      [disabled]="passwordProtectionDisabled">
                    </xrx-toggle-switch>
                  </div>
                  @if (output.passwordProtection) {
                    <div>
                      <div class="w-100 password">
                        <xrx-input
                          type="password"
                          id="encryptionPassword"
                          name="encryptionPassword"
                          autocomplete="off"
                          [(ngModel)]="output.encryptionPassword"
                          minlengtherror="SDE_PASSWORD_LENGTH_INVALID"
                          [minlength]="4"
                          [maxlength]="32"
                          placeholder="SDE_ENTER_PASSWORD3"
                          [required]="output.passwordProtection"
                          [viewPassword]="true"
                          [disabled]="passwordProtectionDisabled"
                          [ngbTooltip]="passwordProtectionToolTip"
                          [disableTooltip]="!passwordProtectionDisabled"
                          [pattern]="passwordProtectionRegex"
                          [patternerror]="passwordProtectionError">
                        </xrx-input>
                      </div>
                      <div
                        class="form-group info min-password-length"
                        [ngClass]="{ disabled: passwordProtectionDisabled }">
                        <span
                          [xdaTranslate]="'SDE_PASSWORD_MINIMUM_LENGTH'"></span>
                      </div>
                    </div>
                  }
                </div>
              }
              <!-- Output selection -->
              <div class="output-selection">
                @if (workflow.output.outputTypeTitle) {
                  <label
                    [xdaTranslate]="workflow.output.outputTypeTitle"></label>
                }
                @if (showThisOutput(OutputType.download)) {
                  <div class="option-toggle">
                    <xrx-toggle-switch
                      [label]="output.selector.items[0].label"
                      [glyph]="output.selector.items[0].glyph"
                      [isMfd]="false"
                      [switchOn]="output.selector.items[0].isOn"
                      (toggle)="
                        updateOutputOptions(output.selector.items[0])
                      "></xrx-toggle-switch>
                  </div>
                }
                <!-- email output option-->
                @if (showThisOutput(OutputType.email)) {
                  <div class="option-toggle">
                    <xrx-toggle-switch
                      [label]="output.emailOptions.label.value"
                      [glyph]="output.emailOptions.glyph.value"
                      [isMfd]="false"
                      [switchOn]="output.selector.items[1].isOn"
                      (toggle)="
                        updateOutputOptions(output.selector.items[1])
                      "></xrx-toggle-switch>
                    @if (output.selector.items[1].isOn) {
                      <div
                        class="output-choice"
                        [ngClass]="{
                          'fax-email':
                            workflow.output.settingTitle ==
                            'SDE_FAX_TRANSMISSION_REPORT',
                        }">
                        @if (allowedEmailDomains) {
                          <div class="info mb-2">{{ allowedEmailDomains }}</div>
                        }
                        <xrx-input
                          type="email"
                          id="recipientEmail"
                          class="recipientEmail"
                          name="recipientEmail"
                          [(ngModel)]="output.email"
                          [maxlength]="254"
                          placeholder="SDE_ENTER_ADDRESS2"
                          [required]="true"
                          label="SDE_RECIPIENT_EMAIL"></xrx-input>
                        <xrx-input
                          type="email"
                          id="confirmEmail"
                          class="confirmEmail"
                          name="confirmEmail"
                          [(ngModel)]="output.confirmEmail"
                          [maxlength]="254"
                          placeholder="SDE_CONFIRM_ADDRESS"
                          autocomplete="off"
                          [required]="true"
                          compareto="recipientEmail"
                          [compareCase]="false"
                          matcherror="SDE_RECIPIENT_CONFIRM_EMAILS"
                          label="SDE_CONFIRM_EMAIL1"
                          error="{{ errorEmail }}"></xrx-input>
                        @if (
                          isAdvancedPlan &&
                          !workflow.isEncryptAndTrackDisabled &&
                          output.emailOptions.encryptAndTrack.visible
                        ) {
                          <div class="output-choice-checkbox-wrapper">
                            <xrx-checkbox
                              label="{{ output.sendEncryptedEmailLabel }}"
                              [(checkBoxValue)]="output.sendEncryptedEmail"
                              name="sendEncrypted"></xrx-checkbox>
                          </div>
                        }
                        @if (output.emailOptions.sourceLink.visible) {
                          <div class="output-choice-checkbox-wrapper">
                            <xrx-checkbox
                              label="SDE_INCLUDE_LINK_SOURCE"
                              [(checkBoxValue)]="input.sendInput"
                              name="sendinput"></xrx-checkbox>
                          </div>
                        }
                        @if (output.emailOptions.sendCondition.visible) {
                          <div
                            class="email-report output-choice-checkbox-wrapper">
                            <xrx-checkbox
                              label="SDE_EMAIL_REPORT_ONLY"
                              [(checkBoxValue)]="output.emailSendOnErrorValue"
                              name="onlyEmailFail"></xrx-checkbox>
                          </div>
                        }
                        @if (
                          !workflow.isSingleService &&
                          output.emailOptions.sendInterim.visible
                        ) {
                          <div class="output-choice-checkbox-wrapper">
                            <xrx-checkbox
                              label="SDE_INCLUDE_OUTPUT_FILE"
                              [(checkBoxValue)]="input.sendInterim"
                              name="sendinterim"></xrx-checkbox>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
                <!-- cloud output option -->
                @if (
                  showThisOutput(OutputType.cloud) &&
                  isAdvancedPlan &&
                  cloudRepos.length
                ) {
                  <div class="option-toggle">
                    <xrx-toggle-switch
                      [label]="output.selector.items[2].label"
                      [glyph]="output.selector.items[2].glyph"
                      [isMfd]="false"
                      [switchOn]="output.selector.items[2].isOn"
                      (toggle)="
                        updateOutputOptions(output.selector.items[2])
                      "></xrx-toggle-switch>
                    @if (output.selector.items[2].isOn) {
                      <div class="output-choice">
                        <xrx-select
                          inlineLabel="SDE_SELECT_REPOSITORY"
                          [list]="cloudRepos"
                          localize="key"
                          property="key"
                          [(selectedItem)]="selectedCloudRepo"
                          (change)="selectCloudRepo($event)"></xrx-select>
                        @if (selectedCloudFolder) {
                          <div class="selected-cloud-folder form-inline">
                            <div class="form-control d-flex align-items-center">
                              <div
                                class="text-truncate"
                                [xdaTranslate]="selectedCloudFolder.name"></div>
                            </div>
                            <button
                              type="button"
                              class="xrx-btn btn-secondary ml-2"
                              (click)="changeCloudFolder()"
                              xdaTranslate>
                              SDE_CHANGE
                            </button>
                            <button
                              type="button"
                              class="xrx-btn btn-secondary btn-short xgl-change"
                              [attr.aria-label]="'SDE_CHANGE' | xdaTranslate"
                              (click)="changeCloudFolder()"></button>
                          </div>
                        }
                        @if (
                          this.cloudRepoIsInvalid && !this.selectedCloudFolder
                        ) {
                          <label class="invalid-options" xdaTranslate
                            >SDE_SELECT_REPOSITORY1</label
                          >
                        }
                        @if (workflow.output.cloudRepoSourceLinkEnabled) {
                          <div class="output-choice-checkbox-wrapper">
                            <xrx-checkbox
                              label="SDE_INCLUDE_SOURCE_FILE"
                              [(checkBoxValue)]="input.sendCloudInput"
                              name="sendCloudInput"></xrx-checkbox>
                          </div>
                        }
                        @if (!workflow.isSingleService) {
                          <div class="output-choice-checkbox-wrapper">
                            <xrx-checkbox
                              label="SDE_INCLUDE_OUTPUT_FILE"
                              [(checkBoxValue)]="input.sendCloudInterim"
                              name="sendCloudInterim"></xrx-checkbox>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
                <!-- Print output options -->
                @if (
                  showThisOutput(OutputType.print) &&
                  workflow.output.printOptions &&
                  !disablePrintOption
                ) {
                  <div class="option-toggle print">
                    <xrx-toggle-switch
                      [label]="output.selector.items[3].label"
                      [glyph]="output.selector.items[3].glyph"
                      [isMfd]="false"
                      [switchOn]="output.selector.items[3].isOn"
                      (toggle)="updateOutputOptions(output.selector.items[3])">
                    </xrx-toggle-switch>
                    @if (output.selector.items[3].isOn) {
                      <span class="info" xdaTranslate>SDE_FILE_WILL_BE</span>
                    }
                    @if (workflow.output.printOptions && !disablePrintOption) {
                      <div class="output-choice">
                        @if (output.selector.items[3].isOn) {
                          <div class="xrx-pt-2">
                            @if (printSettings) {
                              <div>
                                <ul class="action-list">
                                  @for (
                                    item of printSettings;
                                    track item;
                                    let i = $index
                                  ) {
                                    <li>
                                      <xrx-setting
                                        [(setting)]="$any(printSettings)[i]"
                                        [isPrint]="true"
                                        (change)="
                                          item['value'] = $any($event).value
                                        "></xrx-setting>
                                    </li>
                                  }
                                </ul>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
                @if (!outputSelected && workflow.output.outputRequired) {
                  <label class="invalid-options" xdaTranslate
                    >SDE_OUTPUT_TYPE_REQUIRED</label
                  >
                }
              </div>
            </div>
            @if (!workflow.isSingleService || canBeEdited()) {
              <div class="form-group workflow-processing">
                <label xdaTranslate>SDE_WORKFLOW_PROCESSING</label>
                <div class="output-choice-checkbox-wrapper">
                  <xrx-checkbox
                    label="SDE_PAUSE_REVIEW_PROGRESS"
                    [(checkBoxValue)]="input.pauseInterim"
                    name="pauseInterim"></xrx-checkbox>
                </div>
              </div>
            }
            <div class="form-group mt-4 mb-0">
              <button
                type="button"
                class="xrx-btn btn-secondary w-100"
                (click)="resetOutputSettings()">
                <span
                  class="btn-label"
                  [xdaTranslate]="'SDE_RESET_PAGE'"></span>
              </button>
            </div>
          </section>
        }
      }
    </div>
    <div class="modal-footer">
      <div class="modal-footer-left cb">
        @if (step.name === 'output' && this.allowSave) {
          <button
            type="button"
            class="xrx-btn btn-secondary"
            (click)="saveWorkflow()">
            <span class="btn-label" [xdaTranslate]="'SDE_SAVE4'"></span>
          </button>
        }
      </div>
      <div class="modal-footer-right">
        <div class="cb">
          <button
            type="button"
            class="xrx-btn btn-secondary"
            data-dismiss="modal"
            (click)="activeModal.dismiss()">
            <span class="btn-label" [xdaTranslate]="'SDE_CANCEL'"></span>
          </button>
        </div>
        @if (step.index != 0) {
          <div class="cb">
            <button
              type="button"
              class="xrx-btn btn-secondary"
              (click)="stepBack($event, step)">
              <span class="btn-label" [xdaTranslate]="'SDE_BACK'"></span>
            </button>
          </div>
        }
        @if (step.index == steps.length - 1) {
          <div class="cb">
            <button type="submit" class="xrx-btn btn-primary">
              <span class="btn-label" [xdaTranslate]="'SDE_RUN'"></span>
            </button>
          </div>
        }
        @if (step.index < steps.length - 1) {
          <div class="cb">
            <button
              type="button"
              class="xrx-btn btn-primary"
              (click)="stepForward($event, step)">
              <span class="btn-label" [xdaTranslate]="'SDE_NEXT'"></span>
            </button>
          </div>
        }
      </div>
    </div>
  </form>
}
